import { render } from "./MSidebarSegment.vue?vue&type=template&id=257c97d2&scoped=true"
import script from "./MSidebarSegment.vue?vue&type=script&lang=js"
export * from "./MSidebarSegment.vue?vue&type=script&lang=js"

import "./MSidebarSegment.vue?vue&type=style&index=0&id=257c97d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257c97d2"]])

export default __exports__